import StringListResultModelBase from '../_generated/modelBases/string-list-result-model-base';

export default class StringListResultModel extends StringListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
